import React from 'react'

import { useTranslation } from 'react-i18next'

import ExternalLink from '@components/shared/ExternalLink'
import { BLOG_LINK, FAQ_LINK, FEEDBACK_LINK, HELP_CENTER_LINK, SUPPORT_LINK } from '@utils/global'
import PageRoutes from '@utils/page-routes'

const HelpSection: React.FC = () => {
  const { t } = useTranslation()
  return (
    <ul className="p-2.5 basis-1/2 sm:basis-[auto]">
      <li className="font-medium text-md mb-0.5">{t('footer.help.title')}</li>
      <li className="py-0.5">
        <ExternalLink href={HELP_CENTER_LINK}>{t('footer.help.helpCenter')}</ExternalLink>
      </li>
      <li className="py-0.5">
        <ExternalLink href={PageRoutes.usersGuidePath()}>
          {t('footer.help.usersGuide')}
        </ExternalLink>
      </li>
      <li className="py-0.5">
        <ExternalLink href={FAQ_LINK}>{t('footer.help.faq')}</ExternalLink>
      </li>
      <li className="py-0.5">
        <ExternalLink href={BLOG_LINK}>{t('footer.help.blog')}</ExternalLink>
      </li>
      <li className="py-0.5">
        <ExternalLink href={SUPPORT_LINK}>{t('footer.help.support')}</ExternalLink>
      </li>
      <li className="py-0.5">
        <ExternalLink href={FEEDBACK_LINK}>{t('footer.help.feedback')}</ExternalLink>
      </li>
    </ul>
  )
}

export default HelpSection
